import React, { useState } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import ErrorBoundary from './components/ErrorBoundary';
import IntroPage from './components/IntroPage';
import HelpButton from './components/common/HelpButton';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import MapPage from './pages/MapPage';
import AboutPage from './pages/AboutPage';
import ErrorPage from './components/ErrorPage';

const App: React.FC = () => {
  const [showIntro, setShowIntro] = useState(true);

  const handleIntroComplete = () => {
    setShowIntro(false);
  };

  const handleShowIntro = () => {
    setShowIntro(true);
  };

  if (showIntro) {
    return (
      <StyleSheetManager shouldForwardProp={(prop) => !prop.startsWith('$')}>
        <ErrorBoundary>
          <GlobalStyles />
          <IntroPage onComplete={handleIntroComplete} />
        </ErrorBoundary>
      </StyleSheetManager>
    );
  }

  return (
    <StyleSheetManager shouldForwardProp={(prop) => !prop.startsWith('$')}>
      <ErrorBoundary>
        <GlobalStyles />
        <HashRouter>
          <Routes>
            <Route path="/" element={<Layout />} errorElement={<ErrorPage />}>
              <Route index element={<MapPage />} />
              <Route path="home" element={<HomePage />} />
              <Route path="map" element={<MapPage />} />
              <Route path="about" element={<AboutPage />} />
            </Route>
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </HashRouter>
        <HelpButton onClick={handleShowIntro} />
      </ErrorBoundary>
    </StyleSheetManager>
  );
};

export default App;
